import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Select } from '../models/select';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class ProducersService extends BaseService {

  constructor(private http: HttpClient) { super(); }

  search(description: string): Observable<Select[]> {
    return this.http.get<Select[]>(`${this.getUrl("Producers/Search")}/${description}`);
  }
}
